<div class="sb-button-view-only-container" [class.sb-button-view-only]="isViewOnly">
    <div class="position-relative d-inline-flex">
        <button
            #button
            class="sb-icon-button"
            type="button"
            [attr.aria-label]="accessibleName"
            [attr.aria-expanded]="ariaExpanded"
            [ngClass]="buttonStyleClass"
            [disabled]="disabled"
            [matMenuTriggerFor]="menuTrigger"
            #optionsMenuTrigger="matMenuTrigger"
            [matTooltip]="toolTipText"
            matTooltipPosition="below"
            [attr.data-sb-qa]="qaTag"
            (menuClosed)="MenuClosed()"
            (click)="ButtonClicked($event); $event.stopPropagation()">
            @if (icon) {
                <lib-icon
                    [icon]="icon"
                    [size]="iconSize"></lib-icon>
            } @else {
                <div class="d-flex align-items-center">
                    <ng-container *ngTemplateOutlet="profileTemplate"></ng-container>
                </div>
            }
        </button>

        @if (!disabled && badgeText) {
            <lib-badge
                class="position-absolute"
                [style.top.px]="-8"
                [style.right.px]="-8"
                [kind]="BadgeKind.Count"
                [text]="badgeText"></lib-badge>
        }
    </div>

    @if (isViewOnly) {
        <div class="sb-button-view-only-overlay"></div>
    }
</div>

<ng-template #profileTemplate>
    <ng-content select="[profile]"></ng-content>
</ng-template>
